"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedResearch = void 0;
var Tags_1 = require("../Tags");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var SupportedResearch = (function (_super) {
    __extends(SupportedResearch, _super);
    function SupportedResearch() {
        return _super.call(this, {
            cost: 3,
            tags: [Tags_1.Tags.SCIENCE],
            name: CardName_1.CardName.SUPPORTED_RESEARCH,
            cardType: CardType_1.CardType.AUTOMATED,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.party(PartyName_1.PartyName.SCIENTISTS); }),
            metadata: {
                cardNumber: 'T14',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.cards(2);
                }),
                description: 'Requires that Scientists are ruling or that you have 2 delegates there. Draw 2 cards.',
            },
        }) || this;
    }
    SupportedResearch.prototype.play = function (player) {
        player.drawCard(2);
        return undefined;
    };
    return SupportedResearch;
}(Card_1.Card));
exports.SupportedResearch = SupportedResearch;
//# sourceMappingURL=SupportedResearch.js.map